<template>
  <v-card elevation="0" :color="$vuetify.theme.dark ? 'transparent' : 'transparent'" class="pl-3 edit-news">
    <v-container class="custom-container">
      <v-row>
        <v-col cols="12">
          <v-card-title class="pb-0">
            You Can Edit News From Here
          </v-card-title>
        </v-col>
        <v-col cols="12">
          <v-card class="deposit-form px-5" :color="$vuetify.theme.dark ? 'transparent' : 'transparent'">
            <v-row dense>
              <v-col cols="12" sm="12" md="12" class="mb-2">
                <fieldset>
                  <legend>Category</legend>
                  <v-select :items="newsCategories" append-icon="mdi-chevron-down" class="custom-select"
                    v-model="news_category_id" item-text="name" item-value="id"></v-select>
                </fieldset>
              </v-col>
              <v-col cols="12" sm="12" md="12" class="mb-0">
                <fieldset>
                  <legend>Title</legend>
                  <v-text-field label="Enter Title" v-model="title" single-line solo hide-details
                    class="custom-select"></v-text-field>
                </fieldset>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <v-col cols="12">
          <v-card class="px-5 custom-tiny-mce" elevation="0" :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'">
            <tiny-mce-editor-view v-model="description"></tiny-mce-editor-view>
          </v-card>
        </v-col>
        <v-col cols="12">
          <v-btn large tile elevation="0" class="ml-5 text-capitalize btn-account" color="greenMain"
            @click="handleSubmit">
            Submit
          </v-btn>
          <v-btn large tile elevation="0" class="ml-3 text-capitalize btn-account" color="#FF567F" @click="handleReset">
            Reset
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import tinyMceEditorView from "@/components/News/TinyMceEditorView";
import { mapState, mapActions } from "vuex";
import { NEWS__ACTIONS } from "@/store/action-types";
import router from "@/router";
import toast from "@/services/Notification";

export default {
  props: ["id"],
  components: {
    tinyMceEditorView,
  },
  data() {
    return {
      title: null,
      news_category_id: null,
      description: null,
    };
  },
  computed: {
    ...mapState("news", ["newsCategories", "singlenews"]),
    ...mapState("admins", ["loggedAdmin"]),
  },
  methods: {
    ...mapActions("news", [
      NEWS__ACTIONS.NEWSCATEGORIES,
      NEWS__ACTIONS.SINGLENEWS,
      NEWS__ACTIONS.UPDATENEWS,
    ]),

    handleSubmit() {
      this[NEWS__ACTIONS.UPDATENEWS]({
        id: this.id,
        news_category_id: this.news_category_id,
        title: this.title,
        description: this.description,
      });
    },
    handleReset() {
      this.news_category_id = null;
      this.title = null;
      this.description = null;
    },
    setInitialValues() {
      this.news_category_id = this.singlenews.category_id;
      this.title = this.singlenews.name;
      this.description = this.singlenews.description;
    },
  },
  async created() {
    this[NEWS__ACTIONS.NEWSCATEGORIES]();
    this[NEWS__ACTIONS.SINGLENEWS]({ id: this.id });
    this.setInitialValues();
  },
};
</script>
